export const CREATE_CATALOG_WORKPLAN = "CREATE_CATALOG_WORKPLAN";
export const LOAD_CATALOG_WORKPLAN_SUCCESS = "LOAD_CATALOG_WORKPLAN_SUCCESS";
export const CREATE_CATALOG_WORKPLAN_SUCCESS = "CREATE_CATALOG_WORKPLAN_SUCCESS";
export const UPDATE_CATALOG_WORKPLAN_SUCCESS = "UPDATE_CATALOG_WORKPLAN_SUCCESS";
export const DELETE_CATALOG_WORKPLAN_OPTIMISTIC = "DELETE_CATALOG_WORKPLAN_OPTIMISTIC";